<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <after-sale-field
          slot="sr_ascode"
          :label="customLabel.sr_ascode || '售后编号'"
          v-model="form.main.sr_ascode"
          @select="onSelectAfterSale"
        />
        <customer-field
          slot="sr_custname"
          :label="customLabel.sr_custname || '客户名称'"
          v-model="form.main.sr_custname"
          @select="onSelectCustomer"
        />
        <div class="weui-cell" slot="sr_contact">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sr_contact || "联系人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.sr_contact"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="sr_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sr_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.sr_tel"
              placeholder="请输入"
            />
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="sr_urgency"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sr_urgency || "紧急程度"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.sr_urgency"
              placeholder="请选择"
            >
              <option>非常紧急</option>
              <option>一般紧急</option>
              <option>不紧急</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="sr_shelflife"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sr_shelflife || "保质期内"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.sr_shelflife"
              placeholder="请选择"
            >
              <option>是</option>
              <option>否</option>
            </select>
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="srd_prodcode"
              :label="customLabel.srd_prodcode || '产品编号'"
              v-model="item.srd_prodcode"
              @select="onSelectProduct($event, item)"
            />
            <div class="weui-cell" slot="pr_detail">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_detail || "产品名称"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pr_detail }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pr_orispeccode }}
              </div>
            </div>
            <div class="weui-cell" v-if="item.pr_spec" slot="pr_spec">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.pr_spec }}</div>
            </div>
            <div class="weui-cell" v-if="item.pr_unit" slot="pr_unit">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_unit || "单位"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.pr_unit }}</div>
            </div>
            <div class="weui-cell" slot="srd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_qty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.srd_qty"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_currency">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_currency || "币种"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.srd_currency"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_cost">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_cost || "维修费用"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.srd_cost"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_status">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_status || "维修方法"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.srd_status"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_describe">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_describe || "故障描述"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.srd_describe"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_batchcode">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_batchcode || "批次号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.srd_batchcode"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="srd_serial">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.srd_serial || "序列号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.srd_serial"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field
              slot="srd_produced_date"
              :label="customLabel.srd_produced_date || '生产日期'"
              v-model="item.srd_produced_date"
            />
            <order-field
              slot="srd_salecode"
              v-model="item.srd_salecode" :label="customLabel.srd_salecode || '销售订单'"
              @select="onSelectOrder($event, item)"
            />
            <date-field
              slot="srd_purchase_date"
              :label="customLabel.srd_purchase_date || '购买日期'"
              v-model="item.srd_purchase_date"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ProductField from "@/components/field/ProductField.vue";
import DateField from "@/components/field/DateField.vue";
import AfterSaleField from "@/components/field/AfterSaleField.vue";
import OrderField from "@/components/field/OrderField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    ProductField,
    DateField,
    AfterSaleField,
    OrderField,
    CustomerField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/sale/afterSaleRepair",
      codeField: "sr_code",
      statusField: "sr_status_code",
      caller: "AfterSaleRepair",
      xtype: "sale-afterSaleRepair-formpanel",
      form: {
        main: {
          sr_urgency: "非常紧急",
          sr_shelflife: "是",
          sr_custid: null,
          sr_custcode: null,
          sr_custname: null,
        },
        items: [
          {
            srd_prodid: null,
            srd_prodcode: null,
            pr_detail: null,
            pr_orispeccode: null,
            pr_spec: null,
            pr_unit: null,
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        form = me.$route.params.form;
      if (form) {
        var data = me.$route.params.form.main,
          main = me.form.main,
          items = me.form.items;
        main.sr_ascode = data.as_code;
        main.sr_custid = data.as_custid;
        main.sr_custcode = data.as_custcode;
        main.sr_custname = data.as_custname;
        main.sr_contact = data.as_contact;
        main.sr_tel = data.as_tel;
        main.sr_urgency = data.as_urgency;
        main.sr_shelflife = data.as_shelflife;
        items[0].srd_prodcode = data.as_prodcode;
        items[0].srd_prodid = data.as_prodid;
        items[0].pr_detail = data.pr_detail;
        items[0].pr_orispeccode = data.pr_orispeccode;
        items[0].pr_spec = data.pr_spec;
        items[0].pr_unit = data.pr_unit;
        items[0].srd_qty = data.as_qty;
        items[0].srd_describe = data.as_describe;
        items[0].srd_salecode = data.as_salecode;
      }
    },
    onSelectAfterSale(selection) {
      var main = this.form.main,
        items = this.form.items;
      main.sr_custid = selection.as_custid;
      main.sr_custcode = selection.as_custcode;
      main.sr_custname = selection.as_custname;
      main.sr_ascode = selection.as_code;
      main.sr_contact = selection.as_contact;
      main.sr_tel = selection.as_tel;
      main.sr_urgency = selection.as_urgency;
      main.sr_shelflife = selection.as_shelflife;
      items[0].srd_prodid = selection.as_prodid;
      items[0].srd_prodcode = selection.as_prodcode;
      items[0].pr_detail = selection.pr_detail;
      items[0].pr_orispeccode = selection.pr_spec;
      items[0].pr_spec = selection.pr_orispeccode;
      items[0].pr_unit = selection.pr_unit;
    },
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var main = this.form.main;
      main.sr_custname = selection.cu_name;
      main.sr_custid = selection.id;
      main.sr_custcode = selection.cu_code;
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.srd_prodid = selection.id;
      item.srd_prodcode = selection.pr_code;
      item.pr_detail = selection.pr_detail;
      item.pr_spec = selection.pr_spec;
      item.pr_orispeccode = selection.pr_orispeccode;
      item.pr_unit = selection.pr_unit;
    },
    onSelectOrder(selection, item) {
      item.srd_salecode = selection.sa_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        items = me.form.items,
        checked,
        main = me.form.main;
      var count = 0;

      if (!main.sr_custname) {
        me.$weui.topTips("请选择客户", 2000);
      } else {
        items.forEach(function (item) {
          if (!item.srd_prodcode) {
            me.$weui.topTips(`第${count + 1}行产品编号未选择`, 2000);
            return false;
          } else {
            count++;
            item.ad_detno = count;
          }
        });
      }
      checked = count == items.length;
      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        ad_qty: 0,
        productDTO: {},
      });
    },
  },
};
</script>